import React, { forwardRef } from "react";
import { NavLink } from "../NavLink/NavLink";
import { NavItem } from "../NavItem/NavItem";
import { DropdownItem } from "../DropdownItem/DropdownItem";

import classNames from "classnames";
// This code has been copied and modified from https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js
// to better integrate react router with our Bootstrap Navbar
function isModifiedEvent(event: MouseEvent) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function createReactRouterProps({ navigate, onClick, ...rest }: any) {
  return {
    ...rest,
    onClick: (event: MouseEvent) => {
      try {
        if (onClick) onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }
      if (
        !event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore everything but left clicks
        (!rest.target || rest.target === "_self") && // let browser handle "target=_blank" etc.
        !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
        event.preventDefault();
        navigate();
      }
    },
  };
}
export const ReactRouterNavBarLink = forwardRef((_props: any, forwardedRef) => {
  const { children, disabled } = _props;
  let props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return (
    <NavItem className={props.className}>
      <NavLink disabled={disabled} {...props}>
        {children}
      </NavLink>
    </NavItem>
  );
});

export const ReactRouterDropDownLink = forwardRef(
  (_props: any, forwardedRef) => {
    let props = createReactRouterProps(_props);
    props.ref = forwardedRef;
    return (
      <DropdownItem
        active={props.className ? props.className.includes("active") : false}
        disabled={props.disabled}
        {...props}
      ></DropdownItem>
    );
  }
);

export const ReactRouterActionItem = forwardRef((_props: any, forwardedRef) => {
  let props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return (
    <li className={classNames("nav-icon-item", props.className)}>
      <a
        {...props}
        className={classNames("nav-icon", { disabled: props.disabled })}
      >
        {props.children}
      </a>
    </li>
  );
});

export const ReactRouterSideNav = forwardRef((_props: any, forwardedRef) => {
  let props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return (
    <NavItem>
      <NavLink {...props}></NavLink>
    </NavItem>
  );
});
